import { Box, List, ListItem, ListItemIcon, ListItemText } from '@bymason-private/legacy-pattern-components';
import { BatteryDetailItemType, DetailItemType, DetailItemIcon } from './detail-item-icon';

export const getBatteryTypeFromLevel = (level: number): BatteryDetailItemType => {
  if (level >= 75) return 'batteryFull';
  if (level > 25) return 'batteryHalf';
  return 'batteryEmpty';
};

export function LegacyDetailsList({
  addColonToLabel: addColonsToLabel,
  items,
  hideIconsColumn,
  labelWidth,
}: DetailsListProps) {
  const labelDelimiter = addColonsToLabel ? ':' : '';

  return (
    <List disablePadding dense>
      {items.map((item, idx) => (
        <ListItem key={item.type || '' + idx} alignItems='flex-start' sx={{ columnGap: 1, px: 0 }}>
          <Box display='flex' flexWrap='nowrap' sx={{ flex: `0 0 ${labelWidth || 200}px` }}>
            {!hideIconsColumn && (
              <ListItemIcon
                sx={{
                  marginTop: '4px',
                  fontSize: 20,
                }}
              >
                {item.icon ? item.icon : <DetailItemIcon type={item.type} />}
              </ListItemIcon>
            )}
            <ListItemText
              primary={
                <strong>
                  {item.label}
                  {labelDelimiter}
                </strong>
              }
            />
          </Box>
          <ListItemText sx={{ maxWidth: '420px' }} primary={item.value} />
        </ListItem>
      ))}
    </List>
  );
}

export function DetailsListEmpty({ content, inset }: DetailsListEmptyProps) {
  return (
    <List disablePadding dense>
      <ListItem alignItems='flex-start' sx={{ columnGap: 1, px: 0 }}>
        <ListItemText primary={content} inset={inset} />
      </ListItem>
    </List>
  );
}

export interface DetailItem {
  label: React.ReactNode;
  value: React.ReactNode;
  type?: DetailItemType;
  icon?: React.ReactNode;
}
export interface DetailsListProps {
  items: DetailItem[];
  hideIconsColumn?: boolean;
  labelWidth?: number;
  addColonToLabel?: boolean;
}
export interface DetailsListEmptyProps {
  content: React.ReactNode;
  inset?: boolean;
}
